//To check if the return to url is a domain.com
export const checkRedirectURL = (redirectURL: string) => {
  const expression =
    /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi
  const regex = new RegExp(expression)
  const t = redirectURL

  if (t.match(regex)) {
    return true
  } else {
    return false
  }
}
